import { FC } from 'react';
import { ShipIcon, OperationsIcon, StackingIcon } from '@/assets/icons';
import { useTranslation } from 'react-i18next';
import Container from '@/components/Container/Container';
import { Accordion, AccordionTab } from 'primereact/accordion';

import { formatDateAndTime } from '@/utils/formatDate';
import { Schedule } from '../../types';
import styles from './SearchResult.module.scss';
import ScheduleTable from '../../ScheduleTable/ScheduleTable';

type SearchResultProps = {
  result: Schedule;
  modificationsTableData: Schedule[];
  modificationsTableDataLoading: boolean;
};

const SearchResult: FC<SearchResultProps> = ({
  result,
  modificationsTableData,
  modificationsTableDataLoading,
}) => {
  const { t } = useTranslation('schedule');

  const {
    nombre,
    servicio,
    comienzoOperaciones,
    finOperaciones,
    fechaFinDescarga,
    aperturaStacking,
    cierreStacking,
    cutOff,
  } = result;

  return (
    <div className={styles.searchResult}>
      <div
        className={`${styles.row} flex flex-column align-items-start md:flex-row justify-content-start md:align-items-end`}
      >
        <ShipIcon className={`${styles.icon} md:col-1`} />
        <div className={`${styles.resultItem} md:col-6`}>
          <p className={styles.label}>
            {t('searchByShipResult.shipNameLabel')}
          </p>
          <p className={styles.resultValue}>{nombre}</p>
        </div>
        <div className={`${styles.resultItem} md:col-3`}>
          <p className={styles.label}>{t('searchByShipResult.serviceLabel')}</p>
          <p className={styles.resultValue}>{servicio}</p>
        </div>
      </div>
      <div
        className={`${styles.row} flex flex-column align-items-start md:flex-row justify-content-start md:align-items-end`}
      >
        <OperationsIcon className={`${styles.icon} md:col-1`} />
        <div className={`${styles.resultItem} md:col-3`}>
          <h4 className={styles.sectionTitle}>
            {t('searchByShipResult.operations')}
          </h4>
          <p className={styles.label}>
            {t('searchByShipResult.startOperations')}
          </p>
          <p className={styles.resultValue}>
            {formatDateAndTime(comienzoOperaciones)}
          </p>
        </div>
        <div className={`${styles.resultItem} md:col-3`}>
          <p className={styles.label}>
            {t('searchByShipResult.endOperations')}
          </p>
          <p className={styles.resultValue}>
            {formatDateAndTime(finOperaciones)}
          </p>
        </div>
        <div className={`${styles.resultItem} md:col-3`}>
          <p className={styles.label}>
            {t('searchByShipResult.importDelivery')}
          </p>
          <p className={styles.resultValue}>
            {formatDateAndTime(fechaFinDescarga)}
          </p>
        </div>
      </div>
      <div
        className={`${styles.row} flex flex-column align-items-start md:flex-row justify-content-start md:align-items-end`}
      >
        <StackingIcon className={`${styles.icon} md:col-1`} />
        <div className={`${styles.resultItem} md:col-3`}>
          <h4 className={styles.sectionTitle}>
            {t('searchByShipResult.stacking')}
          </h4>
          <p className={styles.label}> {t('searchByShipResult.opening')}</p>
          <p className={styles.resultValue}>
            {formatDateAndTime(aperturaStacking)}
          </p>
        </div>
        <div className={`${styles.resultItem} md:col-3`}>
          <p className={styles.label}> {t('searchByShipResult.closing')}</p>
          <p className={styles.resultValue}>
            {formatDateAndTime(cierreStacking)}
          </p>
        </div>
        <div className={`${styles.resultItem} md:col-3`}>
          <p className={styles.label}> {t('searchByShipResult.lateEntry')}</p>
          <p className={styles.resultValue}>{formatDateAndTime(cutOff)}</p>
        </div>
      </div>
      <Container className={`${styles.backgroundColor} mt-4 mb-3`}>
        <Accordion>
          <AccordionTab
            header={t('historyModifications')}
            headerClassName={styles.headerAccordion}
          >
            <ScheduleTable
              data={modificationsTableData}
              isLoading={modificationsTableDataLoading}
              isHistory
            />
          </AccordionTab>
        </Accordion>
      </Container>
    </div>
  );
};

export default SearchResult;
